import NewPricing from './NewPricing';
import './styles.css';
import PricesLoading from '@/app/Pricing/components/PricesLoading';
import {
  PricingTariffsProvider,
  usePricingTariffs,
} from './context/PricingTariffsContext';
import type { NewPricingProps } from './types';

function PricesContent(props: NewPricingProps) {
  const { isLoading } = usePricingTariffs();

  if (isLoading) {
    return <PricesLoading />;
  }

  return <NewPricing {...props} />;
}

function Prices(props: NewPricingProps) {
  return (
    <PricingTariffsProvider>
      <PricesContent {...props} />
    </PricingTariffsProvider>
  );
}

export default Prices;
